module.exports = __webpack_public_path__ + "static/media/l12_voice_ten_v2.69536017.mp3";